import { getCanvasDimensions, getScaledPageDimensions } from '../catalogHelpers';
import { LANDSCAPE } from '../catalogConstants';

export const initialState = {
    canLoadTableContents: false,
    cummulativeDragX: null,
    cummulativeDragY: null,
    currentPage: 0,
    dimension83: '',
    errorOccurred: false,
    isDragging: false,
    isPageLeft: false,
    isPageRight: false,
    margin: 36,
    mobileScale: 0.5,
    pageOverviewOpen: false,
    QuickViewImport: null,
    scale: 0.875,
    screenOrientation: LANDSCAPE,
    sendToFriendModalIsOpen: false,
    singlePageRatio: 0.81,
    shareOptionsOpen: false,
    showMenuBar: true,
    showRotateBanner: false,
    tabletScale: 0.66,
    thumbnailScale: 0.11,
    zoomedIn: false,
    zoomedScale: 1.5,
};

export function uiReducer(state = initialState, action = {}) {
    switch (action.type) {
        case 'SET_CURRENT_PAGE': {
            return {
                ...state,
                currentPage: action.currentPage,
                isPageLeft: !!action.isPageLeft,
                isPageRight: !!action.isPageRight,
            };
        }
        case 'LOAD_TABLE_CONTENTS': {
            return {
                ...state,
                canLoadTableContents: true,
            };
        }
        case 'TOGGLE_PAGE_OVERVIEW': {
            return {
                ...state,
                pageOverviewOpen: !state.pageOverviewOpen,
                shareOptionsOpen: false,
            };
        }
        case 'TOGGLE_SHARE_OPTIONS': {
            return {
                ...state,
                pageOverviewOpen: false,
                shareOptionsOpen: !state.shareOptionsOpen,
            };
        }
        case 'ZOOM_IN': {
            const canvasDimensions = getCanvasDimensions(
                action.singlePageDimensions,
                state.scale,
                state.margin,
                state.deviceType,
                state.screenOrientation,
                state.singlePageRatio
            );

            // height and width of zoomed page
            const zoomedPageDimensions = getScaledPageDimensions(
                state.currentPage,
                action.pageCount,
                action.singlePageDimensions,
                state.zoomedScale
            );

            // set drag values to zoom into middle of page
            return {
                ...state,
                zoomedIn: true,
                cummulativeDragX: (zoomedPageDimensions.width - canvasDimensions.width) / 2,
                cummulativeDragY: (zoomedPageDimensions.height - canvasDimensions.height) / 2,
            };
        }
        case 'ZOOM_OUT': {
            // also turn off and reset dragging
            return {
                ...state,
                zoomedIn: false,
                cummulativeDragX: null,
                cummulativeDragY: null,
            };
        }
        case 'TURN_ON_DRAG': {
            return {
                ...state,
                isDragging: true,
            };
        }
        case 'TURN_OFF_DRAG': {
            return {
                ...state,
                isDragging: false,
            };
        }
        case 'TRACK_ZOOM_DRAG': {
            return {
                ...state,
                cummulativeDragX: action.cummulativeDragX,
                cummulativeDragY: action.cummulativeDragY,
            };
        }
        case 'SET_PAPER_TYPE_VARS': {
            return {
                ...state,
                dimension83: action.dimension83 || '',
                ...[
                    'margin',
                    'scale',
                    'singlePageRatio',
                    'mobileScale',
                    'tabletScale',
                    'thumbnailScale',
                    'zoomedScale',
                ].reduce(
                    (typeVars, typeVar) => ({
                        ...typeVars,
                        [typeVar]:
                            typeof action[typeVar] !== 'undefined' && action[typeVar] !== null
                                ? action[typeVar]
                                : state[typeVar],
                    }),
                    {}
                ),
            };
        }
        case 'ERROR_OCCURRED': {
            return {
                ...state,
                errorOccurred: true,
            };
        }
        case 'SET_SCREEN_ORIENTATION': {
            return {
                ...state,
                screenOrientation: action.screenOrientation,
            };
        }
        case 'DISPLAY_ROTATE_BANNER': {
            return {
                ...state,
                showRotateBanner: true,
            };
        }
        case 'HIDE_ROTATE_BANNER': {
            return {
                ...state,
                showRotateBanner: false,
            };
        }
        case 'TOGGLE_MENU_BAR': {
            return {
                ...state,
                showMenuBar: !state.showMenuBar,
            };
        }
        case 'SET_QUICK_VIEW_IMPORT': {
            return {
                ...state,
                QuickViewImport: action.QuickViewImport,
            };
        }
        case 'OPEN_SEND_TO_FRIEND_MODAL': {
            return {
                ...state,
                sendToFriendModalIsOpen: true,
            };
        }
        case 'CLOSE_SEND_TO_FRIEND_MODAL': {
            return {
                ...state,
                sendToFriendModalIsOpen: false,
            };
        }
        default:
            return state;
    }
}
